<template>
  <div class="header" style="background-color: #ffffff;
background-image: linear-gradient(315deg, #ffffff 0%, #cea177 74%);
">
    <div class="container-fluid">
      <div class="header-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'base-header',
    props: {
      type: {
        type: String,
         
        description: 'Header background type'
      }
    }
  }
</script>
<style>
</style>
